import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'
import { REGISTER_WRITE_ROLES } from '@/features/medication-register/access'
import { OpenRegisterPage } from '@/features/medication-register/open-register-page'

const searchSchema = z.object({
  // Pre-selection from the client tab's "Open a register" item and the
  // attention page's row: with both present the page opens on Details.
  medicationId: z.string().uuid().optional(),
  clientId: z.string().optional(),
})

/** Opening a register is a manager write (X2). */
export const Route = createFileRoute(
  '/_authenticated/_organization/compliance/drugs-register/open'
)({
  beforeLoad: async () => {
    await requireRoles([...REGISTER_WRITE_ROLES])
    await requireActiveSubscription()
  },
  validateSearch: searchSchema,
  component: OpenRegisterPage,
})
